import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/types/query';
import { RejectNotQualifiedCandidateParams } from '../model';
import { recruiterRejectsCandidateClient } from './client';
import { useRejectCandidateMutationCallbacks } from './use-reject-candidate-mutation-callbacks';

export const useRejectNotQualifiedCandidateMutation = () => {
  const queryClient = useQueryClient();
  const callbacks = useRejectCandidateMutationCallbacks(queryClient);

  return useMutation({
    mutationKey: [QueryKey.useRejectNotQualifiedCandidateMutation],
    mutationFn: async ({
      esPersonId,
      campaignId,
      reason,
      feedback,
      isPositionFilled,
    }: RejectNotQualifiedCandidateParams) => {
      await recruiterRejectsCandidateClient.rejectNotQualifiedCandidate(
        esPersonId,
        campaignId,
        reason,
        feedback,
        isPositionFilled,
      );
      const noteContent = [reason, feedback].filter(Boolean).join(', ');
      await recruiterRejectsCandidateClient.addCandidateNote(esPersonId, {
        content: noteContent,
        campaign: campaignId,
      });
    },
    ...callbacks,
  });
};
